import { classNames as cn, IsInline } from 'helpers';
import type { QuestionProps } from 'types';
import { Choice } from './Choice';

export function Choices({ choices, ...props }: QuestionProps) {
	const cln = cn({ 'col-12': !IsInline(choices) });
	const items = choices.map(choice => <Choice {...props} {...choice} className={cln} key={choice.id} />);
	return <>{items}</>;
}
